import React, { Component } from 'react';
import LayoutViews from '../components/SwipeNav/LayoutViews';
import { FacturesList, FacturesHisto } from '../components/Factures';
import MainDrawer, { ToggleMainDrawer } from '../components/DrawersApp/MainDrawer';
import Fade from '@material-ui/core/Fade';
import NavHeader from '../components/NavHeader/NavHeader';
import ConfirmModal from '../components/PiecesDL/ConfirmModal';
import { connect } from 'react-redux';
import { confs } from '../conf';
import { ToggleLegendDrawer, LegendDrawer } from '../components/Legend';

const { PRIMARY_BG } = confs;

const FacturesHeader = () => (
  <NavHeader title={"Factures"}>
    <ToggleMainDrawer />
    <ToggleLegendDrawer />
  </NavHeader>
);

const navs = [
  {title: 'A télécharger', icon: 'file-pdf', animated: true},
  {title: 'Historique', icon: 'hourglass-end', animated: true},
];

const views = [
  FacturesList,
  FacturesHisto,
];

class Factures extends Component {
  render() {
    return (
        <Fade in={true} mountOnEnter unmountOnExit>
          <>
            <LayoutViews
              primary={PRIMARY_BG}
              header={FacturesHeader}
              navs={navs}
              views={views}
              fixedIndex={0}
            />
            <ConfirmModal />
            <LegendDrawer />
            <MainDrawer />
          </>
        </Fade>
    );
  }
}

export default Factures;
